import classNames from "classnames";
import React from "react";

import Bag from "@assets/sizeChart/Bag.svg?react";
import Beanie from "@assets/sizeChart/Beanie.svg?react";
import Bucket from "@assets/sizeChart/Bucket.svg?react";
import Hat from "@assets/sizeChart/Hat.svg?react";
import HoodedJacket from "@assets/sizeChart/HoodedJacket.svg?react";
import Hoodie from "@assets/sizeChart/Hoodie.svg?react";
import Jacket from "@assets/sizeChart/Jacket.svg?react";
import LongSleeve from "@assets/sizeChart/LongSleeve.svg?react";
import MiniBag from "@assets/sizeChart/MiniBag.svg?react";
import Pants from "@assets/sizeChart/Pants.svg?react";
import Shirts from "@assets/sizeChart/Shirts.svg?react";
import Shorts from "@assets/sizeChart/Shorts.svg?react";
import ShoulderBag from "@assets/sizeChart/ShoulderBag.svg?react";
import SweatShirts from "@assets/sizeChart/Sweatshirts.svg?react";
import Tee from "@assets/sizeChart/Tee.svg?react";
import TrooperHat from "@assets/sizeChart/TrooperHat.svg?react";
import Vest from "@assets/sizeChart/Vest.svg?react";

interface IProps {
  type?: string;
  className?: string;
}

export default function SizeChart({ type, className }: IProps) {
  switch (type) {
    case "bag":
      return <Bag className={classNames(className)} />;
    case "beanie":
      return <Beanie className={classNames(className)} />;
    case "bucket":
      return <Bucket className={classNames(className)} />;
    case "hat":
      return <Hat className={classNames(className)} />;
    case "hoodie":
      return <Hoodie className={classNames(className)} />;
    case "hoodjacket":
      return <HoodedJacket className={classNames(className)} />;
    case "jacket":
      return <Jacket className={classNames(className)} />;
    case "longsleeve":
      return <LongSleeve className={classNames(className)} />;
    case "mini_bag":
      return <MiniBag className={classNames(className)} />;
    case "pants":
      return <Pants className={classNames(className)} />;
    case "pants_new":
      return <Pants className={classNames(className)} />;
    case "shirts":
      return <Shirts className={classNames(className)} />;
    case "shorts":
      return <Shorts className={classNames(className)} />;
    case "shoulder_bag":
      return <ShoulderBag className={classNames(className)} />;
    case "sweatshirts":
      return <SweatShirts className={classNames(className)} />;
    case "tee":
      return <Tee className={classNames(className)} />;
    case "trooper_hat":
      return <TrooperHat className={classNames(className)} />;
    case "vest":
      return <Vest className={classNames(className)} />;

    default:
  }
}
